function ReferPage() {
    return (
      <div><h2>ReferPage</h2></div>
    )
  }
  
  export default ReferPage